var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Password1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0YRgf5kI5uEwsg2Kts5UAa",
    x1: 12.957,
    x2: 6.186,
    y1: 14.058,
    y2: 21.269,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5a505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#e9a804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#f4b102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#fbb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#fdb700"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0YRgf5kI5uEwsg2Kts5UAa)",
    d: "M17.058,31.532l-6.364,6.364L4.33,31.532c-0.396-0.396-0.389-1.025,0-1.414l0.707-0.707 c0.396-0.396,1.018-0.396,1.414,0l1.061,1.061c-0.111,0.77,0.157,1.573,0.707,2.121c0.548,0.552,1.351,0.818,2.121,0.707 c0.509-0.071,1.018-0.311,1.414-0.707s0.636-0.891,0.7-1.407c0.129-0.76-0.151-1.582-0.7-2.128c-0.549-0.55-1.351-0.819-2.121-0.707 l-1.06-1.061c-0.396-0.396-0.389-1.025,0-1.414l0.707-0.707c0.396-0.396,1.018-0.396,1.414,0L17.058,31.532z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0YRgf5kI5uEwsg2Kts5UAb",
    x1: 12.542,
    x2: 26.91,
    y1: 10.409,
    y2: 25.018,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#ffd500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#ffd000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#edbe00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0YRgf5kI5uEwsg2Kts5UAb)",
    d: "M9.708,41.706l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l21.493-21.493l2.828,2.828 L11.122,41.706C10.732,42.096,10.099,42.096,9.708,41.706z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0YRgf5kI5uEwsg2Kts5UAc",
    x1: 24.25,
    x2: 32.492,
    y1: 26.375,
    y2: 26.375,
    gradientTransform: "matrix(.995 -.005 .005 -.995 .012 48.012)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5a505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e9a804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f4b102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#fbb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#fdb700"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0YRgf5kI5uEwsg2Kts5UAc)",
    d: "M27.694,18.12l4.186,4.186c0.777,0.777,0.777,2.037,0,2.814l-0.014,0.014 c-0.777,0.777-2.037,0.777-2.814,0l-4.186-4.186c-0.777-0.777-0.777-2.037,0-2.814l0.014-0.014 C25.657,17.343,26.917,17.343,27.694,18.12z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0YRgf5kI5uEwsg2Kts5UAd",
    x1: 10.628,
    x2: 28.633,
    y1: 54.986,
    y2: 49.482,
    gradientTransform: "scale(1 -1) rotate(-45 -53.69 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#ffd500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#0YRgf5kI5uEwsg2Kts5UAd)",
    d: "M31.201,21.627l-2.828-2.828c-2.924-2.924-2.924-7.682,0-10.607s7.682-2.924,10.607,0 l2.828,2.828c2.924,2.924,2.924,7.682,0,10.607S34.125,24.551,31.201,21.627z M36.15,11.02c-1.364-1.364-3.585-1.364-4.95,0 s-1.364,3.585,0,4.95l2.828,2.828c1.364,1.364,3.585,1.364,4.95,0c1.364-1.364,1.364-3.585,0-4.95L36.15,11.02z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Password1);
export default __webpack_public_path__ + "static/media/icons8-password-1.b18d2b4fed7aba294319bae4daa9eb93.svg";
export { ForwardRef as ReactComponent };